import React, { useState, useEffect } from 'react'
import { Panel, Button, Input, ControlLabel, Message, Radio, RadioGroup } from 'rsuite'
import { useParams, useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  updateSignContract,
  updateUncertified,
  saveOpenBankAccount,
} from '../../redux/actions/contract'
import pathname from '../../constants/pathname'

export default function SendPanelWithRequestNoteWidget(props) {
  const {
    showCommandButton,
    schema,
    isDirectorSendApprove,
    isManagerApprove,
    isDirectorMoreRequest,
    isManagerUncertified,
    isDirectorUncertified,
    isOpenBankAccount,
  } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [memo, setMemo] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)
  const [approveType, setApproveType] = useState()
  const [approveError, setApproveError] = useState('')

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const handleCallService = async () => {
    setShowConfirm(false)
    let request = {
      projectVersionId: projectId,
      userId: '',
      value: memo,
      isApproved: approveType == 1 ? true : false,
    }
    console.log('request', JSON.stringify(request))
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      var response

      if (isDirectorSendApprove) {
        console.log('isDirectorSendApprove', isDirectorSendApprove)
        response = await updateSignContract(request, projectId)
        console.log('response', response)
        if (response.success) {
          //success jump to new page
          setShowConfirm(false)
          setIsError(false)
          doneLoading()
          setIsLoading(false)
          sessionStorage.setItem('projectId', response.model.projectVersionId)
          sessionStorage.setItem('param', '')

          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        } else {
          doneLoading()
          setIsLoading(false)
          setShowConfirm(false)
          setIsError(response.errorMessage)
          return
        }
      } else if (isManagerApprove) {
        response = await updateSignContract(request, projectId)
        if (response.success) {
          //success jump to new page
          setShowConfirm(false)
          setIsError(false)
          doneLoading()
          setIsLoading(false)
          sessionStorage.setItem('projectId', response.model.projectVersionId)
          sessionStorage.setItem('param', '')
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        } else {
          doneLoading()
          setIsLoading(false)
          setShowConfirm(false)
          setIsError(response.errorMessage)
          return
        }
      } else if (isDirectorMoreRequest) {
        //response = await updateUncertified(request, projectId)
      } else if (isManagerUncertified) {
        response = await updateUncertified(request, projectId)
      } else if (isDirectorUncertified) {
        response = await updateUncertified(request, projectId)
      } else if (isOpenBankAccount) {
        response = await saveOpenBankAccount(request, projectId)
      }

      // if (isManagerApprove) {
      //   console.log('response', response)
      //   if (response.success && response?.model?.isSuccess) {
      //     setShowConfirm(false)
      //     setIsError(false)
      //     doneLoading()
      //     setIsLoading(false)
      //     return history.push(
      //       `${pathname.proposal.overview.overviewCoworker}/${response.model.projectVersionId}`
      //     )
      //   } else {
      //     setShowConfirm(false)
      //     setIsError(true)
      //   }
      // } else {  }

      if (response.success) {
        //success jump to new page
        setShowConfirm(false)
        setIsError(false)
        doneLoading()
        setIsLoading(false)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      }

      setShowConfirm(false)
    } catch (e) {
      console.log(e?.response?.data)
      if (e?.response?.data) {
        setIsError(e?.response?.data?.errorMessage)
      }
    }
    setShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    setMemo(data.note)
    if (data.approveType) {
      setApproveType(data.approveType)
    }
    setShowConfirm(true)
  }

  return (
    <div>
      <Panel
        header={schema?.header}
        collapsible
        defaultExpanded
        bordered
        shaded
        style={{ marginBottom: 10 }}
      >
        <ControlLabel>{requiredFiled(schema.note.validators, schema.note.label)}</ControlLabel>
        <ErrorMessage error={errors[schema.note.name]} />
        <br />
        <Input
          name={schema.note.name}
          inputRef={register(isValidators(schema.note.validators))}
          rows={3}
          placeholder={schema.note.label}
          componentClass="textarea"
          defaultValue={schema.note.value}
        />

        {schema.approveType && (
          <>
            <br />
            <Controller
              key={schema.approveType.name}
              name={schema.approveType.name}
              control={control}
              rules={isValidators(schema.approveType.validators)}
              defaultValue={schema.approveType.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.approveType?.options?.map((item) => {
                      return <Radio value={item.value}>{item.label} </Radio>
                    })}
                  </RadioGroup>
                )
              }}
            />
          </>
        )}

        {showCommandButton && (
          <>
            <hr />
            {isError && <Message showIcon type="error" description={isError} />}
            {approveError && <Message showIcon type="error" description={approveError} />}

            <Button
              style={{ width: 'auto' }}
              //appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={handleSubmit(onSubmit)}
              disabled={isLoading}
            >
              {schema.buttonText}
            </Button>
          </>
        )}
      </Panel>

      <ConfirmWidget
        title={`ยืนยันการ${schema.buttonText}`}
        show={showConfirm}
        detail={`กรุณายืนยันการ${schema.buttonText}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      />
    </div>
  )
}
